import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import './GridMotion.css';

const GridMotion = ({ items = [], gradientColor = 'black' }) => {
  const rowRefs = useRef([]);
  const mouseXRef = useRef(window.innerWidth / 2);
  const quickSetters = useRef([]);

  const totalItems = 28;
  const defaultItems = Array.from(
    { length: totalItems },
    (_, index) => `Item ${index + 1}`
  );
  const combinedItems =
    items.length > 0 ? items.slice(0, totalItems) : defaultItems;

  useEffect(() => {
    gsap.ticker.lagSmoothing(0);

    const maxMoveAmount = 300;
    const baseDuration = 0.8;
    const inertiaFactors = [0.6, 0.4, 0.3, 0.2];

    // Inicializar setters una sola vez
    quickSetters.current = rowRefs.current.map((row, index) =>
      gsap.quickTo(row, 'x', {
        duration: baseDuration + inertiaFactors[index % inertiaFactors.length],
        ease: 'power3.out',
        overwrite: true
      })
    );

    let rafId = null;

    const animate = () => {
      const progress = mouseXRef.current / window.innerWidth;
      const baseMove = progress * maxMoveAmount - maxMoveAmount / 2;

      quickSetters.current.forEach((setX, index) => {
        const direction = index % 2 === 0 ? 1 : -1;
        setX(baseMove * direction);
      });

      rafId = null;
    };

    const handleMouseMove = e => {
      mouseXRef.current = e.clientX;

      if (!rafId) {
        rafId = requestAnimationFrame(animate);
      }
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <div className="noscroll loading">
      <section
        className="intro"
        style={{
          background: `radial-gradient(circle, ${gradientColor} 0%, transparent 100%)`
        }}
      >
        <div className="gridMotion-container">
          {[...Array(4)].map((_, rowIndex) => (
            <div
              key={rowIndex}
              className="row"
              ref={el => (rowRefs.current[rowIndex] = el)}
            >
              {[...Array(7)].map((_, itemIndex) => {
                const content = combinedItems[rowIndex * 7 + itemIndex];

                return (
                  <div key={itemIndex} className="row__item">
                    <div
                      className="row__item-inner"
                      style={{ backgroundColor: '#111' }}
                    >
                      {content ? (
                        <div
                          className="row__item-img"
                          style={{
                            backgroundImage: `url(${content})`
                          }}
                        />
                      ) : (
                        <div className="row__item-content">
                          {content}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
        <div className="fullview" />
      </section>
    </div>
  );
};

export default GridMotion;
